import { AccountMembership } from '@mkp/account-membership/models';
import { createActionGroup, props } from '@ngrx/store';

export const activeUsersActions = createActionGroup({
  source: 'Active Users',
  events: {
    'Delete Account Membership': props<{
      accountMembership: AccountMembership;
      isSelfDelete: boolean;
    }>(),
  },
});
